// screen: Help link without a tenant — https://studio.viewstream.co.il/help/<topic> (the API reference at /docs links
// here) opens that topic in the signed-in user's current tenant; signed out, the login comes first and returns here.
import { createFileRoute, Navigate, useRouterState } from '@tanstack/react-router';
import { Skeleton } from '@viewstream/ui';
import { useAuth } from '~/app/auth';

export const Route = createFileRoute('/help/$topic')({ component: HelpEntry });

function HelpEntry() {
  const { topic } = Route.useParams();
  const hash = useRouterState({ select: (s) => s.location.hash });
  const { me, loading } = useAuth();
  if (loading) return <div className="p-8"><Skeleton className="h-8 w-48" /></div>;
  const here = `/help/${encodeURIComponent(topic)}`; // the section anchor does not survive the login round trip
  if (!me?.user) return <Navigate to="/login" search={{ next: here }} />;
  const slug = me.current_tenant?.slug ?? me.tenants[0]?.slug;
  if (!slug) return <Navigate to="/login" search={{ next: undefined }} />;
  return <Navigate to={'/t/$slug/help/$topic' as never} params={{ slug, topic } as never} hash={hash || undefined} />;
}
